import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { isSuccess } from '@orus.eu/result'

import { PharaohNextScope } from '#/lib/pharaoh-next/pharaoh-next-scope.tsx'
import { CustomerEnvironmentTools } from '#/shared/components/customer-shell/components/customer-environment-tools.tsx'
import { CustomerShell } from '#/shared/components/customer-shell/customer-shell.tsx'
import { buildLoginHref } from '#/shared/routing/build-login-href.ts'
import { requireCustomerSession } from '#/shared/routing/require-customer-session.ts'

export const Route = createFileRoute('/(customer)/_shell')({
  // The customer-session guard has passed. Page-specific permissions stay on child routes.
  beforeLoad: ({ context }) => requireCustomerSession(context),
  loader: async ({ context }) => {
    const { queryClient, trpc } = context
    const sessionResult = await context.session.getSessionResult()
    if (!isSuccess(sessionResult)) return

    const permissions = sessionResult.output.allPermissions
    if (permissions.includes('contract.read')) {
      void queryClient.prefetchQuery(trpc.contracts.listMyContracts.queryOptions())
    }
    if (permissions.includes('user.read')) {
      // A deleted-account check is only possible when this session can read its account.
      const account = await queryClient.ensureQueryData(trpc.users.loadMyInformation.queryOptions())
      if (account === null) {
        await context.session.logout()
        throw redirect({ href: buildLoginHref() })
      }
    }
  },
  component: ShellLayout,
})

function ShellLayout() {
  return (
    <PharaohNextScope surface="fo">
      <CustomerEnvironmentTools />
      <CustomerShell>
        <Outlet />
      </CustomerShell>
    </PharaohNextScope>
  )
}
